import { ClientIntegration, ManualNotificationType } from "@avenueops/shared-types";
import { SmartForm } from "@avenueops/web-components";
import { NotificationFilterType } from "@prisma/client";
import CustomNotifications from "components/monitors/editFormReboot/CustomNotifications";
import { useWatch } from "react-hook-form";

interface Props {
  notificationPrefix: string;
  intercomIntegrations: ClientIntegration[];
}

export function IntercomNotificationInput({ notificationPrefix, intercomIntegrations }: Props) {
  const notification: ManualNotificationType = useWatch({ name: notificationPrefix });

  return (
    <>
      <div className="col-span-4">
        <SmartForm.DropdownSelect
          name={`${notificationPrefix}.integrationId`}
          defaultValue={intercomIntegrations.length === 1 ? intercomIntegrations[0].integrationId : undefined}
          title="Integration Instance"
          options={intercomIntegrations.map((integration) => ({
            label: integration.name ?? "Intercom integration",
            value: integration.integrationId,
          }))}
        />
      </div>
      <div className="col-span-6">
        <CustomNotifications
          notificationPrefix={notificationPrefix}
          notificationType={notification.manualType}
          supportedTypes={[NotificationFilterType.COMMENT, NotificationFilterType.STATUS_UPDATE_THREAD]}
        />
      </div>
    </>
  );
}
